module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/changing_okumart-d57f8aa6baea1168a560813ea0654495.jpg";